import messages from '../lang/it-IT.json'
import { overrideCommon } from './common'

// here we import the local labels for this country and export the common labels merged with the local ones

export default overrideCommon(messages)
